export default "__VITE_ASSET__C$IdMXAo__"